import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, DefaultButton, PrimaryButton, Overlay, Spinner, mergeStyleSets } from '@fluentui/react';


const getClassNames = (hasButtons) => mergeStyleSets({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'stretch',
    padding: '24px 32px',
    minWidth: '350px',
    minHeight: '200px',
    height: '200px',
    boxSizing: 'border-box',
  },
  message: {
    margin: '0 12px 8px 12px',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: hasButtons ? '400' : '600',
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    margin: '8px 0 16px 0',
    minHeight: '60px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .ms-Spinner-circle': {
      width: '40px',
      height: '40px',
      borderWidth: '3px',
    },
    '& .ms-Spinner-label': {
      fontSize: '14px',
      marginTop: '4px',
      color: '#605e5c',
      textAlign: 'center',
      minHeight: '18px',
    },
  },
  buttonsBlock: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
    margin: '8px 0 8px -16px',

    selectors: {
      '& > *': {
        flexGrow: 1,
        flexBasis: 0,
        marginLeft: '16px',
      },
    },
  },
});

export const DefaultLayerHostZ = 1000000;

const Const = {
  overlayStyle: { root: { zIndex: DefaultLayerHostZ - 2 } }
};

const OverlayProgress = ({ task }) => {
  const data = task;
  const [isCanceling, setIsCanceling] = useState(false);

  useEffect(() => {
    !task && setIsCanceling(false);
  }, [task]);

  if (!data) { return null; }
  if (!Object.keys(data).length) { return <Overlay styles={Const.overlayStyle} /> }

  const { text, description, cancelToken, buttons = [], withSpinner } = data;
  const message = isCanceling ? 'Cancelling...' : text;
  const hasButtons = buttons.length > 0;

  const classNames = getClassNames(hasButtons);

  function handleClick() {
    setIsCanceling(true);
    cancelToken && cancelToken.cancel('Canceled by user');
  }

  return (
    <Modal isOpen={!!data} isBlocking={true} isDarkOverlay={true} containerClassName={classNames.container} scrollableContentClassName={classNames.content}>
      {message && <div className={classNames.message}>{message}</div>}
      {withSpinner && <Spinner size={3} label={description} className={classNames.spinner} />}
      {!!buttons.length &&
        <div className={classNames.buttonsBlock}>
          {buttons.map(button => <DefaultButton {...button} />)}
        </div>
      }
      {cancelToken && !buttons.length && <PrimaryButton text="Cancel" disabled={isCanceling} onClick={handleClick} />}
    </Modal>
  )
}

OverlayProgress.propTypes = {
  task: PropTypes.object,
}

export default OverlayProgress;
